/**
 * Badge Component
 *
 * A reusable badge component that follows the StartupHive design system.
 *
 * Props:
 * - children: Badge content (required)
 * - variant: 'primary' | 'success' | 'warning' | 'info' (default: 'primary')
 * - className: additional CSS classes
 * - ...rest: any other span attributes
 */

function Badge({
  children,
  variant = 'primary',
  className = '',
  ...rest
}) {
  const variantClass = `badge-${variant}`
  const classes = `badge ${variantClass} ${className}`.trim()

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  )
}

export default Badge
